import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookOpen, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { BlogCard } from "@/pages/Blog";

export const BlogSection = () => {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog", { params: { limit: 3 } }).then(({ data }) => setPosts(data)).catch(() => {}); }, []);
  if (posts.length === 0) return null;
  return (
    <section className="bg-[#0A0A0A] py-20 border-t border-white/5" data-testid="blog-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-end justify-between mb-10 flex-wrap gap-3">
          <div>
            <div className="font-overline text-xs text-[#D4AF37] mb-3 flex items-center gap-2"><BookOpen className="w-3 h-3" /> — CONSIGLI & GUIDE</div>
            <h2 className="font-display font-black text-3xl md:text-5xl tracking-tighter leading-none">IMPARA A SCEGLIERE</h2>
          </div>
          <Link to="/blog" className="font-overline text-xs text-[#D4AF37] hover:text-white flex items-center gap-1" data-testid="blog-section-all">TUTTI GLI ARTICOLI <ArrowRight className="w-3 h-3" /></Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">{posts.map((p) => <BlogCard key={p.slug} post={p} />)}</div>
      </div>
    </section>
  );
};
